// src/components/IQAC.js
import React from 'react';

const IQAC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-indigo-900 tracking-tight mb-4">
            Internal Quality Assurance Cell (IQAC)
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Sumatidevi Tompe Institute is committed to fostering a culture of continuous improvement and excellence in education. The IQAC plays a pivotal role in developing and implementing quality benchmarks across academic and administrative activities.
          </p>
        </div>

        {/* Hero / Visual Section */}
        <div className="mb-16 rounded-2xl overflow-hidden shadow-2xl border border-gray-200">
          <img
            src="https://images.lifestyleasia.com/wp-content/uploads/sites/7/2022/09/20125559/iim.jpeg"
            alt="Beautiful Indian college campus representing quality education"
            className="w-full h-80 md:h-96 object-cover"
          />
          <div className="bg-gradient-to-t from-black/60 to-transparent absolute inset-0 flex items-end p-8">
            <p className="text-white text-xl font-medium">
              Committed to Excellence • Continuous Improvement • Stakeholder-Centric Quality
            </p>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100">
          <h2 className="text-3xl font-bold text-indigo-800 mb-6 border-b border-indigo-100 pb-4">
            Functions of IQAC
          </h2>

          <ul className="space-y-5 text-gray-700 text-lg">
            <li className="flex items-start">
              <span className="text-indigo-600 text-2xl mr-4 mt-1">✓</span>
              <span>
                Developing quality parameters for various academic and administrative activities.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-indigo-600 text-2xl mr-4 mt-1">✓</span>
              <span>
                Facilitating the creation of a learner-centric environment conducive to quality education.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-indigo-600 text-2xl mr-4 mt-1">✓</span>
              <span>
                Collecting and analyzing feedback from all stakeholders including students, faculty, alumni, and employers.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-indigo-600 text-2xl mr-4 mt-1">✓</span>
              <span>
                Documenting various programs and activities leading to quality improvement and institutional excellence.
              </span>
            </li>
          </ul>

          {/* Optional additional sections */}
          <div className="mt-12 pt-8 border-t border-gray-200">
            <h3 className="text-2xl font-semibold text-indigo-800 mb-6">
              Our Commitment
            </h3>
            <p className="text-gray-700 leading-relaxed">
              IQAC at Sumatidevi Tompe Institute ensures that the institution remains aligned with national and global quality standards while promoting innovation, inclusivity, and continuous enhancement in every aspect of institutional functioning.
            </p>
          </div>
        </div>

        {/* Call to Action / Future Content Placeholder */}
        <div className="mt-12 text-center">
         
          <p className="mt-4 text-sm text-gray-500">
            {/* Add members list, annual reports, AQAR documents, meeting minutes, etc. here in future */}
          </p>
        </div>
      </div>
    </div>
  );
};

export default IQAC;